import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode as decode } from 'jwt-decode'

import Swal from "sweetalert2";
import axios from 'axios';


export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [token, setToken] = useState('')
  const [isAuth, setIsAuth] = useState(false)
  const [user, setUser] = useState({})
  const [paymentStatus, setPaymentStatus] = useState('')
  const [shouldShowPaymentWarning, setShouldShowPaymentWarning] = useState(false)

  // Function to check if current date is between 10th and end of month
  const isInPaymentPeriod = () => {
    const today = new Date();
    const currentDay = today.getDate();
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
    return currentDay >= 10 && currentDay <= lastDayOfMonth;
  };

  // Function to check payment status from API
  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(import.meta.env.VITE_URL_SALDO_SISTEMIFY);
      const { estado } = response.data;
      setPaymentStatus(estado);
      
      // Show warning if status is "Con Adeudo" and we're in payment period
      if (estado === "Con Adeudo" && isInPaymentPeriod()) {
        setShouldShowPaymentWarning(true);
      } else {
        setShouldShowPaymentWarning(false);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentStatus('');
      setShouldShowPaymentWarning(false);
    }
  };

  const loginUser = (token)=>{
    localStorage.setItem('app_token', token)
    localStorage.setItem('tema', "white-content")
    const decoded = decode(token)
    setToken(token)
    setIsAuth(true)
    setUser(decoded)
    // Check payment status after successful login
    checkPaymentStatus();
  }

  const logoutUser = (user)=>{
    localStorage.removeItem('app_token')
    setToken({})
    setIsAuth(false)
    setUser(null)
    setPaymentStatus('')
    setShouldShowPaymentWarning(false)
  }

  const salir =()=>{
    const token = localStorage.getItem('app_token')
    let dateNow = Math.floor(Date.now()/1000)
    const decoded = decode(token)
    let timexp = decoded.exp
    if (dateNow >= timexp){
      localStorage.removeItem('app_token')
      setToken({})
      setIsAuth(false)
      setUser(null)
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Tu sesion ha caducado",
        showConfirmButton: false,
        timer: 2000,
      });
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000);
    }
  }
  

  useEffect(()=>{
    const item = localStorage.getItem('app_token')
    if (item){
      const decoded = decode(item)
      setToken(item)
      setIsAuth(true)
      setUser(decoded)
      salir()
      // Check payment status when loading existing session
      checkPaymentStatus();
    }
  }, [])

  return (
        <AuthContext.Provider
      value={{
        token,
        isAuth,
        user,
        paymentStatus,
        shouldShowPaymentWarning,
        loginUser,
        logoutUser,
        checkPaymentStatus,
      }}
      >
      { props.children }
    </AuthContext.Provider>
  )
};

export default AuthContextProvider;